import Vue from 'vue';

// Polyfill for vue-input-facade on IE
// (not included in core-js)
import 'custom-event-polyfill';

import Component from 'vue-class-component';

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteLeave',
	'beforeRouteUpdate'
]);

import { vuetify } from './config/plugins/vuetify';
import './config/plugins/vue-dot';
import './config/plugins/form-builder';
import './config/plugins/vue-browser-acl';

import '@/theme/styles.scss';

import App from './App.vue';
import router from './config/router/router';
import store from './store/';
import { i18n } from './i18n';
import { pinia } from '@/config/plugins/pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import registerComponents from './components/globals';
registerComponents(Vue);

import { registerDirectives } from '@cnamts/vue-dot/src/helpers/registerDirectives';
import { directives } from '@/directive';
import useUserInfoStore from './store/UserInfoStore';
registerDirectives(Vue, directives);

// Remove "tip" from browser console
Vue.config.productionTip = false;

// For persistence and rehydration of Pinia stores
pinia.use(piniaPluginPersistedstate);

useUserInfoStore(pinia);

new Vue({
	router,
	store,
	i18n,
	vuetify,
	pinia,
	render: (h) => h(App)
}).$mount('#app');
